'use strict';

const { DOMESTIC, LOCAL } = require('./ShippingConstants.json');
const React = require('react');
const PropTypes = require('prop-types');
const { getValidQuote } = require('./shippingHelpers.es');
const get = require('lodash.get');

function QuotePrimary({ quotes, currency }) {
    let handlingTimeCopy = '';

    if (quotes.domestic.length) {
        handlingTimeCopy = get(getValidQuote({
            quotes: quotes.domestic,
            regionType: DOMESTIC,
            currency
        }), 'handlingTimeCopy', '');
    } else if (quotes.local.length) {
        handlingTimeCopy = get(getValidQuote({
            quotes: quotes.local,
            regionType: LOCAL,
            currency
        }), 'handlingTimeCopy', '');
    }

    if (handlingTimeCopy) {
        return <div data-tn="shipping-handling">{handlingTimeCopy}</div>;
    }
    return null;
}

QuotePrimary.propTypes = {
    quotes: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired
};

module.exports = QuotePrimary;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/QuoteHandling.jsx